import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { SHOPIFY_CONFIG } from '../shopify/config/shopify.tokens';
import { ShopifyApiError } from '../shopify/errors/shopify-api.error';

export const shopifyTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const config = inject(SHOPIFY_CONFIG);

  if (!request.url.includes('myshopify.com')) {
    return next(request);
  }

  const authenticatedRequest = request.clone({
    setHeaders: {
      'X-Shopify-Storefront-Access-Token': config.storefrontAccessToken,
    },
  });

  return next(authenticatedRequest);
};

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
  return next(request).pipe(
    catchError((error: unknown) => {
      // Only normalize Shopify Storefront errors; leave forms API errors intact.
      if (!request.url.includes('myshopify.com')) {
        return throwError(() => error);
      }

      const shopifyError = ShopifyApiError.fromUnknown(error);
      console.error(`Shopify API [${request.method} ${request.url}]:`, shopifyError.message);
      return throwError(() => shopifyError);
    }),
  );
};
